import logo from './logo.svg';
import './App.css';
import './components/clock/clock';
import Clock from './components/clock/clock';

function App() {
  return (
    <div className="App">
      <Clock></Clock>
    </div>
  );
}

export default App;
